import compact from "lodash/compact";
import forEach from "lodash/forEach";
import head from "lodash/head";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import React, { memo, useMemo } from "react";
import locale from "./edgeAttributes.locale";
const SIZES = {
    BLOCK_HEIGHT: 16
};
const fieldBlockStyle = {
    height: SIZES.BLOCK_HEIGHT,
    lineHeight: `${SIZES.BLOCK_HEIGHT - 1}px`
};
const comparisonBlockStyle = {
    height: SIZES.BLOCK_HEIGHT - 2,
    lineHeight: `${SIZES.BLOCK_HEIGHT - 3}px`
};
function EdgeAttributes(props) {
    var _a, _b;
    const attributesMap = useMemo(() => { var _a; return (((_a = props.from) === null || _a === void 0 ? void 0 : _a.Attributes) ? keyBy(props.from.Attributes, "Id") : undefined); }, [(_a = props.from) === null || _a === void 0 ? void 0 : _a.Attributes]);
    const inputFields = useMemo(() => {
        var _a;
        if (!attributesMap || !((_a = props.data.Input) === null || _a === void 0 ? void 0 : _a.Fields))
            return undefined;
        const result = [];
        forEach(props.data.Input.Fields, field => {
            const fieldNames = compact(map(field.Ids, id => {
                var _a, _b;
                const firstProperty = (_a = head(id)) === null || _a === void 0 ? void 0 : _a.Value;
                return firstProperty ? (_b = attributesMap[firstProperty]) === null || _b === void 0 ? void 0 : _b.Name : undefined;
            }));
            if (fieldNames.length) {
                result.push({ fields: fieldNames, comparison: field.Comparison });
            }
        });
        return result;
    }, [attributesMap, (_b = props.data.Input) === null || _b === void 0 ? void 0 : _b.Fields]);
    return (React.createElement("div", { className: props.className }, inputFields &&
        map(inputFields, (inputField, index) => (React.createElement("div", { className: "border-bottom-gray-100 pt-0_75 pb-0_75 pl-xs pr-xs flex-single-row flex-wrap with-gap-xxs", key: index }, map(inputField.fields, (name, ind) => [
            React.createElement("div", { key: `${name}_${ind}`, style: fieldBlockStyle, className: "bg-primary-100 text-primary-600 border-rounded-small w-max-content pl-0_5 pr-0_5 nowrap text-overflow-ellipsis font-small" }, name),
            ind !== inputField.fields.length - 1 &&
                (inputField.comparison === "and" || inputField.comparison === "or") ? (React.createElement("div", { key: `${name}_${ind}_${inputField.comparison}`, style: comparisonBlockStyle, className: "bg-gray-050 text-gray-500 border-rounded-small w-max-content pl-0_5 pr-0_5 font-small" }, inputField.comparison === "and" ? locale.AND : locale.OR)) : null
        ]))))));
}
export default memo(EdgeAttributes);
